import { useState } from "react";
import PageWrapper from "../../component/page-wrapper";
import styles from "./index.module.scss";
import { Loading } from "@quark/design";
import { postSetKv } from "../../api";
import { Notification } from "@quark/design";
import { useSearchParams } from "react-router-dom";

const ContactPage = () => {
  const [params] = useSearchParams();
  console.log(params);
  const [form, setForm] = useState({
    name: "",
    company: "",
    phone: "",
    wechat: "",
    message: "",
    type: params.get("type") || "",
  });

  const types = [
    { label: "商务合作", value: "business" },
    { label: "校园合作", value: "school" },
    { label: "私有部署", value: "private" },
    { label: "其他", value: "others" },
  ];

  const [loading, setLoading] = useState(false);

  const checkValid = (): boolean => {
    const { name, company, phone, wechat, type } = form;
    if (!name || !company || !phone || !wechat || !type) {
      Notification.error("请检查表单", {
        duration: 3000,
        position: "topCenter",
      });
      return false;
    }
    return true;
  };

  const submit = () => {
    Notification.dispose();
    if (!checkValid()) return;
    setLoading(true);
    postSetKv(`contact-${Date.now()}`, form)
      .then(() => {
        Notification.success("提交成功", {
          duration: 3000,
          position: "topCenter",
        });
      })
      .catch(() => {
        Notification.error("提交失败，请重试", {
          duration: 3000,
          position: "topCenter",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PageWrapper>
      <div className={styles.content}>
        <div className={styles.title}>联系我们</div>
        <div className={styles.desc}>
          如果你有合作需求，请填写并提交以下信息，我们会尽快联系您。
        </div>
        <div className={styles.form}>
          <div className={styles.left}>
            {/* 称呼 */}
            <div className={styles.label}>
              怎么称呼您
              <i>*</i>
            </div>
            <input
              className={styles.input}
              placeholder="请输入"
              onChange={(e) =>
                setForm({
                  ...form,
                  name: e.target.value,
                })
              }
            />
            {/* 企业名称 */}
            <div className={styles.label}>
              企业名称
              <i>*</i>
            </div>
            <input
              className={styles.input}
              placeholder="请输入"
              onChange={(e) =>
                setForm({
                  ...form,
                  company: e.target.value,
                })
              }
            />

            {/* 手机 */}
            <div className={styles.label}>
              手机号码
              <i>*</i>
            </div>
            <input
              className={styles.input}
              placeholder="请输入"
              onChange={(e) =>
                setForm({
                  ...form,
                  phone: e.target.value,
                })
              }
            />
            {/* 微信号码 */}
            <div className={styles.label}>
              微信号码
              <i>*</i>
            </div>
            <input
              className={styles.input}
              placeholder="请输入"
              onChange={(e) =>
                setForm({
                  ...form,
                  wechat: e.target.value,
                })
              }
            />
            {/* 留言 */}
            <div className={styles.label}>留言</div>
            <textarea
              className={styles.textarea}
              rows={4}
              placeholder="请描述您的需求"
              onChange={(e) =>
                setForm({
                  ...form,
                  message: e.target.value,
                })
              }
            />
          </div>
          {/* right */}
          <div className={styles.right}>
            <div>
              <div className={styles.label}>
                合作类型 <i>*</i>
              </div>
              <div className={styles.types}>
                {types.map((type) => (
                  <div className={styles.type} key={type.value}>
                    <input
                      type="radio"
                      name="type"
                      value={type.value}
                      checked={form.type === type.value}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          type: e.target.value,
                        })
                      }
                    />
                    <span>{type.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.submit} onClick={submit}>
              {loading ? <Loading /> : "提交"}
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ContactPage;
